import './offers-counter.less';

export default angular.module('cian.newbuild.filter.offersCounter', [])
  .directive('offersCounter', () => ({
    restrict: 'E',
    template: require('./offers-counter.html'),
    controller: [
      'MetaService',
      'SerpListService',
      (MetaService, SerpListService) => {
        const ctrl = {};

        ctrl.count = MetaService.lastMeta ?
          MetaService.lastMeta.count :
          SerpListService.getOffersCount();

        MetaService.onReceive(data => {
          ctrl.count = data && data.count;
        });

        ctrl.isUpdating = MetaService.isUpdating;

        ctrl.pluralForms = {
          one: 'Найден {$ offersCounter.count | number $} объект',
          few: 'Найдено {$ offersCounter.count | number $} объекта',
          many: 'Найдено {$ offersCounter.count | number $} объектов',
        };

        return ctrl;
      }],
    controllerAs: 'offersCounter',
  }))
  .name;



// WEBPACK FOOTER //
// ./src/serp/directives/offers-counter/offers-counter.dir.js